import { Minus } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgSubtract = mkIcon(Minus);